import Typography from '@components/_atoms/Typography';
import ProductAlarmLabel from '@components/_organism/service/ProductAlarmLabel';
import { AlarmProductType } from '@components/_templates/seller/SellerPromoteAlramContent/types';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { gray } from '@styles/Colors';
import { useTranslation } from 'next-i18next';

type Props = {
  readonly productList: AlarmProductType[];
  readonly deleteAll: () => void;
  readonly onClose: (index: number) => void;
};

const Layout = styled.div``;
const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;
const TableTitle = styled(Typography)``;
const DeleteAllButton = styled(Typography)``;
const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default function ProductAlarmLabelTable({ productList, deleteAll, onClose }: Props) {
  const { t } = useTranslation('materialnoti');
  return (
    <Layout>
      <TextContainer>
        <TableTitle variant={TypoVariant.SH3}>{t('mypage.title')}</TableTitle>
        <DeleteAllButton variant={TypoVariant.SH3} color={gray.gray5} style={{ cursor: 'pointer' }} onClick={deleteAll}>
          {t('mypage.clear-btn')}
        </DeleteAllButton>
      </TextContainer>
      <ProductList>
        {productList.length ? (
          productList?.map((product, index) => (
            <ProductAlarmLabel
              key={index}
              data={product}
              onClose={() => {
                onClose(index);
              }}
            />
          ))
        ) : (
          <EmptyProductAlarmList />
        )}
      </ProductList>
    </Layout>
  );
}

const EmptyLayout = styled.div`
  margin: auto;
  padding: 200px 0;
`;
const EmptyProductAlarmList = () => {
  const { t } = useTranslation('materialnoti');
  return (
    <EmptyLayout>
      <Typography variant={TypoVariant.B3} color={gray.gray6}>
        {t('mypage.empty')}
      </Typography>
    </EmptyLayout>
  );
};
